var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgRightArrow = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5195 10.4286C12.5195 10.2679 12.4392 10.0871 12.3186 9.96652L2.95703 0.604909C2.8365 0.484375 2.65569 0.404016 2.49498 0.404016C2.33426 0.404016 2.15346 0.484375 2.03292 0.604909L1.02846 1.60938C0.907924 1.72991 0.827567 1.91071 0.827567 2.07143C0.827567 2.23214 0.907924 2.41295 1.02846 2.53348L8.92355 10.4286L1.02846 18.3237C0.907924 18.4442 0.827567 18.625 0.827567 18.7857C0.827567 18.9665 0.907924 19.1272 1.02846 19.2478L2.03292 20.2522C2.15346 20.3728 2.33426 20.4531 2.49498 20.4531C2.65569 20.4531 2.8365 20.3728 2.95703 20.2522L12.3186 10.8906C12.4392 10.7701 12.5195 10.5893 12.5195 10.4286Z",
    fill: "#CE2D50"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRightArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/right-arrow.4b6c5196.svg";
export { ForwardRef as ReactComponent };